//import api from '../api';
import { newAPIPost } from '../api/index.js';
import dateFormat from '../utils/dateFormat';

export default {
    state: {
        FSIDailyreport: [],
        searchRequest: {},
      },

      mutations: {
        updateFSIDR(state, FSIDailyreport) {
          state.FSIDailyreport = FSIDailyreport;
        },
        updateSearchFSIDRRequest(state, searchRequest) {
          state.searchRequest = searchRequest;
        },
      },


      actions: {
        async FSIDRList({ commit, state }, request) {
          const fallbackRequest = request || state.searchRequest;
          const requestToSend = JSON.parse(JSON.stringify(fallbackRequest))

          if (requestToSend.apptDate.startDate)
          {
            requestToSend.apptDate.startDate = dateFormat.getLocalDateOnly(requestToSend.apptDate.startDate);
          }

          if (requestToSend.apptDate.endDate)
          {
            requestToSend.apptDate.endDate = dateFormat.getLocalDateEnd(requestToSend.apptDate.endDate);
          }
          else{
            requestToSend.apptDate.endDate = dateFormat.getLocalDateEnd(requestToSend.apptDate.startDate);
          }

          console.log(requestToSend);
          const st = performance.now();
          //const result = await api.post('/api/w/fsi/GetIBSInbound', requestToSend);
          const result = await newAPIPost('/api/w/fsi/GetIBSInbound', requestToSend);
          commit('updateSearchFSIDRRequest', fallbackRequest);
          console.log(JSON.stringify(result));
          return commit('updateFSIDR', result);
                },
      },

      getters: {
        getFSIDailyreport: state => state.FSIDailyreport,
      },
}
